import { useIsInIframe } from "./use-in-iframe";
import { useLocalStorage } from "./use-local-storage";
import { HIDE_CHAT_SIDEBAR_KEY } from "../types/constants";

export function useHideChatSidebar() {
  const inIframe = useIsInIframe();
  const { storageData } = useLocalStorage(HIDE_CHAT_SIDEBAR_KEY);
  return inIframe && storageData === "true";
}
